import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import InfiniteScroll from "react-infinite-scroll-component";

import { makeStyles } from '@material-ui/core/styles'
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import List from '@material-ui/core/List'
import CircularProgress from '@material-ui/core/CircularProgress'

import Copie from '../components/Copie'
import { issueService } from '../services/issueService'

const useStyles = makeStyles(theme => ({
    root: {
      flexGrow: 1,
      paddingTop: 10,
    },
    fullWidth: {
        width: '100%',
    },
}));

const RESULTS_PER_PAGE = 30;

function Issues(props) {
    const classes = useStyles();
    const itemState = useSelector(state => state.item)

    const [loading, setloading] = useState(false);
    const [copies, setCopies] = useState({
        offset: 0,
        list: [],
        finished: false,
    });

    const handleConnectionError= () => {
        if(props.history.location.pathname !== '/issues')
            return
        
        props.history.replace({
            pathname: '/issue',
            state: {
                error: true,
                message: 'Um erro aconteceu na conexão. Por favor tente novamente em alguns instantes.'
            }
        })
    }

    const fetchData = () => {
        issueService(itemState.item['registro-sistema'], RESULTS_PER_PAGE, copies.offset)
        .then(response => {
            setCopies({
                ...copies,
                list: copies.list.concat(response.data),
                offset: copies.offset + response.data.length,
                finished: response.data.length < RESULTS_PER_PAGE
            })
        })
        .catch(() => handleConnectionError())
        .finally(() => setloading(false))
    }    

    useEffect(() => {
        setloading(true)
        fetchData()
    }, [])

    const Spinner = () => (
        <Box display="flex" flexGrow={1} p={2} justifyContent="center">
            <CircularProgress></CircularProgress>
        </Box>
    )    

    return (
        <Box className={classes.root}>

            <InfiniteScroll
                dataLength={copies.list.length}
                next={fetchData}
                hasMore={!copies.finished}
                loader={ <Spinner /> }
            >
                <List>
                    {copies.list.map((item, index) => 
                        <Copie item={item} key={index}></Copie>)
                    }
                </List>
            </InfiniteScroll>

            <Box display="flex" p={1} justifyContent="center">
                {!loading &&
                    <Button 
                        color="primary" 
                        fullWidth={true}
                        onClick={ () => props.history.goBack() }>
                            Voltar
                    </Button>
                }
            </Box>
        </Box>
    );
}

export default Issues;